import { useQuery } from "@tanstack/react-query";
import { useState } from "react";
import axios from "../apis/axios";
import { getToken } from "../utilities";

function useGet({
  url,
  initialParams = {},
  onSuccess = () => {},
  onError = () => {},
  enabled = true,
  method = "GET",
}) {
  const [paramsObject, setParamsObject] = useState(initialParams);

  const fetchData = async () => {
    // Convert paramsObject to query string
    const queryParams = new URLSearchParams(paramsObject).toString();
    const requestUrl = queryParams ? `/${url}?${queryParams}` : `/${url}`;

    let fd = new FormData();
    if (method !== "GET") {
      for (const key in paramsObject) {
        if (paramsObject.hasOwnProperty(key)) {
          fd.append(key, paramsObject[key]);
        }
      }
    }

    const response = await axios({
      method: method,
      url: requestUrl,
      data: method !== "GET" ? fd : null,
      headers: { Authorization: getToken() ? `Bearer ${getToken()}` : "" },
    });

    return response.data;
  };

  const data = useQuery([url, paramsObject], fetchData, {
    refetchOnWindowFocus: false,
    retry: false,
    enabled: enabled,
    onSuccess: (data) => {
      onSuccess(data);
    },
    onError: (err) => {
      onError(err);
    },
  });

  return { paramsObject, setParamsObject, data };
}

export default useGet;
